import createPalette, {
  PaletteOptions,
} from '@mui/material/styles/createPalette';

const paletteOptions: PaletteOptions = {
  common: {
    black: '#000',
    white: '#FFF',
  },
  primary: {
    main: '#039BE5',
    dark: '#008BCE',
    light: '#00ACFF',
  },
  secondary: {
    dark: '#039BE5',
    main: '#008BCE',
    light: '#00ACFF',
  },
  text: {
    primary: '#FFF',
    secondary: '#039BE5',
    disabled: '#E1E1E1',
  },
  error: {
    light: '#FF5454',
    main: '#DE3A3A',
  },
  warning: {
    main: '#FFD454',
    light: '#FFD987',
  },
  success: {
    light: '#62E133',
    main: '#5ACD30',
    dark: '#51BA2B',
  },
  divider: '#E1E1E1',
  background: {
    default: '#17212B',
  },
};

const palette = createPalette(paletteOptions);

export default palette;
